export default (camelCaseString) => (
  camelCaseString.replace(/[A-Z]/g, (match, offset) => (
    (offset !== 0 ? '_' : '') + match.toLowerCase()
  ))
);
